import { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { styles } from '../../assets/styles';
import '../../assets/animations.css';
import { HowToPlay } from '../../data/modalText';
import { ModalBox } from '../containers';

export default function HowToButton() {
  const [isHovering, setIsHovering] = useState(false);

  const handleMouseOver = () => {
    setIsHovering(true);
  };

  const handleMouseOut = () => {
    setIsHovering(false);
  };

  const [open2, setOpen2] = useState(false);

  const handleOpen2 = () => {
    setOpen2(true);
  };

  const handleClose2 = () => {
    setOpen2(false);
  };

  return (
    <>
      <Button
        disableRipple
        className="pokeball-icon-button"
        onMouseOver={handleMouseOver}
        onMouseOut={handleMouseOut}
        onClick={handleOpen2}
        sx={styles.howButton}
      >
        {' '}
        {isHovering && <Box sx={styles.buttonHowHoverBox}>How to play</Box>}
      </Button>

      <ModalBox open2={open2} handleClose2={handleClose2}>
        <Typography variant="h4" sx={styles.howToVariantH4}>
          {HowToPlay.Title}
        </Typography>
        {' '}
        <Typography variant="h6" sx={styles.howToVariantH62}>
          {' '}
          {HowToPlay.Tutorial}
          {' '}
        </Typography>
        <Typography variant="h6" sx={styles.howToVariantH62}>
          {HowToPlay.Tutorial2}
          {' '}
        </Typography>
        <Typography variant="h6" sx={styles.howToVariantH62}>
          {HowToPlay.Tutorial3}
          {' '}
        </Typography>
        <Typography variant="h6" sx={styles.howToVariantH62}>
          <span style={styles.modalColor3}>Green</span>
          {' '}
          {HowToPlay.IndicationsGreen}
          <br />
          <span style={styles.modalColor4}>Yellow</span>
          {' '}
          {HowToPlay.IndicationsYellow}
          <br />
          <span style={styles.modalColor5}>Red</span>
          {' '}
          {HowToPlay.IndicationsRed}
          <br />
          {HowToPlay.IndicationsArrow}
        </Typography>
        <Typography variant="h4" sx={styles.howToVariantH4}>
          Properties
        </Typography>
        <Typography variant="h6" sx={styles.howToVariantH62}>
          {HowToPlay.PropertiesTitle}
        </Typography>
        <Typography variant="h5" sx={styles.howToVariantH5}>
          Generation
          {' '}
        </Typography>
        <Typography variant="h6" sx={styles.howToVariantH62}>
          {HowToPlay.PropertiesGen}
        </Typography>
        <Typography variant="h6" sx={styles.howToVariantH6}>
          <span style={styles.modalColor2}>{HowToPlay.ValuesTitle}</span>
          {HowToPlay.PropertiesGenValues}
        </Typography>
        <Typography variant="h5" sx={styles.howToVariantH5}>
          Types
          {' '}
        </Typography>
        <Typography variant="h6" sx={styles.howToVariantH62}>
          {HowToPlay.PropertiesTypes}
        </Typography>
        <Typography variant="h6" sx={styles.howToVariantH6}>
          <span style={styles.modalColor2}>{HowToPlay.ValuesTitle}</span>
          {HowToPlay.PropertiesTypesValues}
        </Typography>
        <Typography variant="h5" sx={styles.howToVariantH5}>
          Abilities
          {' '}
        </Typography>
        <Typography variant="h6" sx={styles.howToVariantH62}>
          {HowToPlay.PropertiesAbilities}
        </Typography>
        <Typography variant="h6" sx={styles.howToVariantH6}>
          <span style={styles.modalColor2}>{HowToPlay.ValuesTitle}</span>
          {HowToPlay.PropertiesAbilitiesValues}
        </Typography>
        <Typography variant="h5" sx={styles.howToVariantH5}>
          Weight
          {' '}
        </Typography>
        <Typography variant="h6" sx={styles.howToVariantH62}>
          {HowToPlay.PropertiesWeight}
        </Typography>
        <Typography variant="h6" sx={styles.howToVariantH6}>
          <span style={styles.modalColor2}>{HowToPlay.ValuesTitle}</span>
          {HowToPlay.PropertiesWeightValues}
        </Typography>
        <Typography variant="h5" sx={styles.howToVariantH5}>
          Height
          {' '}
        </Typography>
        <Typography variant="h6" sx={styles.howToVariantH62}>
          {HowToPlay.PropertiesHeight}
        </Typography>
        <Typography variant="h6" sx={styles.howToVariantH6}>
          <span style={styles.modalColor2}>{HowToPlay.ValuesTitle}</span>
          {HowToPlay.PropertiesHeightValues}
        </Typography>
        <Typography variant="h5" sx={styles.howToVariantH5}>
          Total base stats
          {' '}
        </Typography>
        <Typography variant="h6" sx={styles.howToVariantH62}>
          {HowToPlay.PropertiesStats}
        </Typography>
        <Typography variant="h6" sx={styles.howToVariantH6}>
          <span style={styles.modalColor2}>{HowToPlay.ValuesTitle}</span>
          {HowToPlay.PropertiesStatsValues}
        </Typography>
      </ModalBox>
    </>
  );
}

export function HowToButtonCries() {
  const [isHovering, setIsHovering] = useState(false);

  const handleMouseOver = () => {
    setIsHovering(true);
  };

  const handleMouseOut = () => {
    setIsHovering(false);
  };

  const [open2, setOpen2] = useState(false);

  const handleOpen2 = () => {
    setOpen2(true);
  };

  const handleClose2 = () => {
    setOpen2(false);
  };

  return (
    <>
      <Button
        disableRipple
        className="pokeball-icon-button"
        onMouseOver={handleMouseOver}
        onMouseOut={handleMouseOut}
        onClick={handleOpen2}
        sx={styles.howButton}
      >
        {' '}
        {isHovering && <Box sx={styles.buttonHowHoverBox}>How to play?</Box>}
      </Button>

      <ModalBox open2={open2} handleClose2={handleClose2}>
        <Typography variant="h4" sx={styles.howToVariantH4}>
          {HowToPlay.Title}
        </Typography>
        {' '}
        <Typography variant="h6" sx={styles.howToVariantH62}>
          {' '}
          {HowToPlay.Tutorial}
          {' '}
        </Typography>
        <Typography variant="h6" sx={styles.howToVariantH62}>
          {HowToPlay.Tutorial3}
          {' '}
        </Typography>
        <Typography variant="h6" sx={styles.howToVariantH62}>
          <span style={styles.modalColor6}>Green</span>
          {' '}
          {HowToPlay.IndicationsGreen}
          <br />
          <span style={styles.modalColor5}>Red</span>
          {' '}
          {HowToPlay.IndicationsRed}
          <br />
        </Typography>
        <Typography variant="h4" sx={styles.howToVariantH4}>
          Cry mode
        </Typography>
        <Typography variant="h6" sx={styles.howToVariantH62}>
          {' '}
          {HowToPlay.TutorialCry}
          {' '}
        </Typography>
        <Typography variant="h6" sx={styles.howToVariantH62}>
          {' '}
          {HowToPlay.TutorialCry2}
          {' '}
        </Typography>
        <Typography variant="h6" sx={styles.howToVariantH63}>
          {' '}
          Good luck.
          {' '}
        </Typography>
      </ModalBox>
    </>
  );
}

export function HowToButtonEmoji() {
  const [isHovering, setIsHovering] = useState(false);

  const handleMouseOver = () => {
    setIsHovering(true);
  };

  const handleMouseOut = () => {
    setIsHovering(false);
  };

  const [open2, setOpen2] = useState(false);

  const handleOpen2 = () => {
    setOpen2(true);
  };

  const handleClose2 = () => {
    setOpen2(false);
  };

  return (
    <>
      <Button
        disableRipple
        className="pokeball-icon-button"
        onMouseOver={handleMouseOver}
        onMouseOut={handleMouseOut}
        onClick={handleOpen2}
        sx={styles.howButton}
      >
        {' '}
        {isHovering && <Box sx={styles.buttonHowHoverBox}>How to play?</Box>}
      </Button>

      <ModalBox open2={open2} handleClose2={handleClose2}>
        <Typography variant="h4" sx={styles.howToVariantH4}>
          {HowToPlay.Title}
        </Typography>
        {' '}
        <Typography variant="h6" sx={styles.howToVariantH62}>
          {' '}
          {HowToPlay.Tutorial}
          {' '}
        </Typography>
        <Typography variant="h6" sx={styles.howToVariantH62}>
          {HowToPlay.Tutorial3}
          {' '}
        </Typography>
        <Typography variant="h6" sx={styles.howToVariantH62}>
          <span style={styles.modalColor6}>Green</span>
          {' '}
          {HowToPlay.IndicationsGreen}
          <br />
          <span style={styles.modalColor5}>Red</span>
          {' '}
          {HowToPlay.IndicationsRed}
          <br />
        </Typography>
        <Typography variant="h4" sx={styles.howToVariantH4}>
          Emoji mode
        </Typography>
        <Typography variant="h6" sx={styles.howToVariantH62}>
          {' '}
          {HowToPlay.TutorialEmoji}
          {' '}
        </Typography>
        <Typography variant="h6" sx={styles.howToVariantH63}>
          {' '}
          Good luck.
          {' '}
        </Typography>
      </ModalBox>
    </>
  );
}
